import { OUTLOOK_RT_INTRO, OUTLOOK_RT_SLUG } from '@/content/outlookRetail'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The thirteenth report with a designed page of its own, and the fourth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the Manufacturing
  // and Consumer Goods ones (*"referans alarak ilgili sayfayı birebir tıpa tıp
  // aynısını tasarla"*) with a four-part full-page capture of the live page and
  // all six of the images it carries. See `content/outlookRetail.ts` and
  // `pages/OutlookRetail.tsx`.
  ...outlook(
    OUTLOOK_RT_SLUG,
    'Retail',
    undefined,
    'future-2030-outlook-retail-cover',
    '636651a6-03a5-4fc3-b42d-e515614be86e-future-2030-digital-transformation-outlook-retail.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the three
  // outlook entries below, and for the same reason: this page draws its hero from
  // `OUTLOOK_RT_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`.
  body: [`${OUTLOOK_RT_INTRO.lede} ${OUTLOOK_RT_INTRO.body}`],
  layout: 'retail-outlook',
  // Its own words, its cover, its file and all six of its images, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookRetailChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 27
